import React from "react"
import {DatePicker, Form} from "antd"
import {CustomInput} from "../../../components/Custom/Input"
import {useTranslation} from "react-i18next";
import 'moment/locale/ru'
import 'moment/locale/be'
import {maskMap} from "../../../api/types";
import moment from "moment";

const IssueDocInput = (props: any) => {
    const {t} = useTranslation(['resources', 'translation'])
    const {i18n} = useTranslation();

    return (
        <>
            <Form.Item
                label={t('AppUserModelDateDoc')}
                name="dateDoc"
                rules={[
                    {
                        required : true,
                        message : t('validation:RequiredField')
                    }
                ]}
            >
                <DatePicker
                    allowClear
                    format={maskMap[i18n.language]}
                    disabledDate={d => !d || d.isAfter(moment(new Date()))}
                    style={{width: '100%', height: '36px'}}
                />
            </Form.Item>
            <Form.Item
                label={t('AppUserModelOrganDoc')}
                name="organDoc"
                rules={[
                    {
                        required : true,
                        message : t('validation:RequiredField')
                    },
                    {
                        min: 3,
                        max : 150,
                        message : t('validation:LengthErr')
                    }
                ]}
            >
                <CustomInput
                    allowClear
                    autoComplete="off"
                    maxLength={200}
                    placeholder={t('AppUserModelOrganDoc')}
                />
            </Form.Item>
        </>
    )
}

export default IssueDocInput
